<template>
  <div class="slider-inner slider-c">
    <Logo />

    <div class="c1 animated fadeInUp">
      <div class="inner">
        <img src="~images/c/c_p_1.png" />
      </div>
    </div>
    <img class="c2 animated zoomIn" src="~images/c/c_2.png" />
    <img class="c3 animated fadeIn" src="~images/c/c_3.png" />
    <div class="c4 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/c/c_4.png" />
    </div>
    <div class="c5 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/c/c_5.png" />
    </div>
    <img class="c6" src="~images/b/b_9.png" />
    <div class="c7 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_3.png" />
    </div>
    <div class="c8 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_4.png" />
    </div>
    <div class="c9 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_5.png" />
    </div>
    <img class="c10 animated fadeInLeft" src="~images/b/b_7.png" />
    <img class="c11 animated fadeInRight" src="~images/c/c_6.png" />

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderC",
};
</script>

<style lang="less" scoped>
.slider-c {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .c1 {
    position: absolute;
    top: 20%;
    right: 5%;
    left: 5%;
    height: 4rem;
    padding: 0.5rem;
    background: url("~images/c/c_1.png") center top / 100% 100%;
    box-sizing: border-box;
    .inner {
      img {
        padding: 0.5rem 0;
      }
    }
  }
  .c2 {
    position: absolute;
    top: 13.5%;
    left: 50%;
    width: 4.42rem;
    margin-left: -4.42/2rem;
  }
  .c3 {
    position: absolute;
    bottom: 1.65rem;
    left: 0;
    width: 100%;
  }
  .c4 {
    position: absolute;
    top: 7.65rem;
    left: 0.57rem;
    width: 1.5rem;
  }
  .c5 {
    position: absolute;
    bottom: 1.02rem;
    right: 1.06rem;
    width: 0.98rem;
    z-index: 3;
  }
  .c6 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
  }
  .c7 {
    position: absolute;
    top: 15%;
    left: 0.86rem;
    width: 0.52rem;
    img {
      animation-delay: 0.3s;
    }
  }
  .c8 {
    position: absolute;
    top: 17%;
    right: 0;
    width: 1.44rem;
    img {
      animation-delay: 1s;
    }
  }
  .c9 {
    position: absolute;
    top: 5.8rem;
    right: 0.1rem;
    width: 0.79rem;
    img {
      animation-delay: 0.8s;
    }
  }
  .c10 {
    position: absolute;
    width: 5rem;
    left: 0;
    top: 9.98rem;
    animation-delay: 0.8s;
  }
  .c11 {
    position: absolute;
    width: 6rem;
    right: 0;
    top: 7.2rem;
    animation-delay: 1s;
  }
}
</style>